import { isBotPServed } from '@wui/im'

import { useLocalization } from '@/shared/composables/localization'
import { fromPServedUser, isPServedIsUser } from '@/shared/utils/uri'

import {
  isBotMemberNumber,
  resolveBotContact,
  toBotPServed,
} from './bot-search'

export {
  getBotPServedFromSearchQuery,
  hasRealBotName,
  isBotCatalogSearchQuery,
  isBotMemberNumber,
  isBotPlaceholderName,
  matchesBotTokenSearch,
  matchesPublicBotSearch,
  parseBotSearchToken,
  pickBetterNamedContact,
  publicBotToContact,
  publicBotToRoomListItem,
  resolveBotContact,
  resolvePublicBotPServed,
  toBotPServed,
  userBotToContact,
} from './bot-search'
export {
  loadPublicBots,
  resolveBotDisplayName,
  searchBotsForQuery,
} from './search-bots-for-query'
export {
  BOT_CONTROL_P_SERVED,
  findMatchingSystemBotContacts,
  getSystemBotContact,
  matchesSystemBotContactSearch,
  matchesSystemBotPServedQuery,
  matchesSystemBotSearch,
  mergeSystemBotSearchResults,
  systemBotToContact,
} from './system-bots'

export const getUnknownContactLabel = (pServed: string) => {
  const { t } = useLocalization()

  if (isBotPServed(pServed) || isBotMemberNumber(pServed)) {
    return resolveBotContact(isBotPServed(pServed) ? pServed : toBotPServed(pServed)).name
  }

  if (isPServedIsUser(pServed)) {
    return `${t('common.subscriber')} ${fromPServedUser(pServed)}`
  }

  return t('common.externalContact')
}
